import { render, staticRenderFns } from "./UserSettingsEmailReport.vue?vue&type=template&id=62c38cd0"
import script from "./UserSettingsEmailReport.vue?vue&type=script&lang=js"
export * from "./UserSettingsEmailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports